<template>
  <div class="flex flex-col items-center">
    <Title :title="title"></Title>
    <div class="md:flex md:flex-wrap md:items-center" style="width: 60%">
      <div class="flex flex-col items-center md:w-1/3 pb-16" v-for="(tech, key) in techs" v-bind:key="tech">
        <img v-bind:src="tech.path"
             width=128
             height=128
             v-bind:alt="tech.alt"
             v-bind:data-aos="getRandomFlip"
             data-aos-duration="2000" />
        <p class="text-3xl font-bold pt-5">{{ key }}</p>
        <p class="pt-2"><strong>Expertise level:</strong> {{ tech.expertise }}</p>
        <p v-if="tech.frameworks"><strong>Frameworks:</strong> {{ tech.frameworks.toString() }}</p>
        <p v-if="tech.testingLibraries"><strong>Testing libraries:</strong> {{ tech.testingLibraries.toString() }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Title from './Title';

export default {
  name: "Tech",

  props: {
    title: String,
    techs: Object
  },

  components: {
    Title
  },

  data() {
    return {
      possibleFlips: ['flip-left', 'flip-right', 'flip-up', 'flip-down']
    }
  },

  computed: {
    getRandomFlip: function () {
      return this.possibleFlips[Math.floor(Math.random() * this.possibleFlips.length)];
    }
  },
}
</script>

<style scoped>

</style>